import styled from 'styled-components';
import { Text12Light, Text13Bold, Text14Regular, Text24Bold } from '../../../components/utils/Text/Text.styles';
import Input from '../../../components/utils/inputs/Input/Input';
import NumericInput from '../../../components/utils/inputs/NumericInput/NumericInput';

export const PageContainer = styled.div`
  max-height: 100dvh;
  height: 100%;
  display: flex;

  @media only screen and (max-width: 768px) {
    max-height: calc(100dvh - 5.6rem);
  }
`;

export const Title = styled(Text24Bold)`
  letter-spacing: -0.408px;
  margin-left: 1.6rem;
  margin-bottom: 1.6rem;
`;

export const Navigator = styled.nav`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2.4rem 0;
  min-width: 38rem;
  border-right: 1px solid #f3f4f6;
  background-color: #fff;

  @media screen and (max-width: 1100px) {
    max-width: 55rem;
  }

  @media screen and (max-width: 900px) {
    max-width: 25rem;
    min-width: 25rem;
  }

  @media screen and (max-width: 768px) {
    min-width: unset;
    max-width: unset;
    width: 100%;
    border-right: none;
  }
`;

export const Content = styled.div`
  overflow: scroll;
  width: 100%;
`;

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100% - 5.6rem);
`;

export const ListContainer = styled.div`
  overflow: auto;
  height: calc(100% - 5.6rem);
  display: flex;
  flex-direction: column;
`;

export const RowItem = styled.div`
  padding: 1.6rem 1.2rem;
  display: flex;
  gap: 0.8rem;
  align-items: center;
  border-bottom: 1px solid #f3f4f6;
  cursor: pointer;
`;

export const RowContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const NumOfUsersText = styled(Text14Regular)`
  opacity: 0.68;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Filter = styled.div`
  background: #f3f4f6;
  height: 3.8rem;
  padding: 0.4rem;
  display: flex;
`;

export const FilterButton = styled.button`
  background: ${({ $selected }) => ($selected ? '#FFF' : 'transparent')};
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #170c2f;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.8rem;
  letter-spacing: -0.5px;
  opacity: ${({ $selected }) => !$selected && '0.5'};
  border-radius: 8px;
  border: ${({ $selected }) => $selected && '1px solid #E5E7EB'};
  box-shadow: ${({ $selected }) => $selected && '4px 5px 2px 0 rgba(0, 0, 0, 0), 2px 3px 2px 0 rgba(0, 0, 0, 0.01)'};
`;

export const ContentHeader = styled.div`
  height: 7rem;
  border-bottom: 1px solid #f3f4f6;
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.02);
  align-items: center;
  display: flex;
  padding-left: 1.6rem;
`;

export const ContentContainer = styled.div`
  overflow: auto;
  align-content: flex-end;
  padding: 1.6rem;
  height: 100%;
  max-height: ${({ $footerHeight }) => `calc(100% - ${$footerHeight}px - 9rem)`};
  background: #f3f4f6;
`;

export const Footer = styled.form`
  padding: 1.6rem 2.4rem 1.6rem 2.4rem;
  border-top: 1px solid #f3f4f6;
  background: #fff;
  box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.02);
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

export const FooterButton = styled.button`
  min-width: 4.6rem;
  height: 4.6rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $active }) => ($active ? 'linear-gradient(93deg, #3e9be4 6.75%, #1672ba 93.25%)' : '#f5f5f5')};
  position: relative;
  &:disabled {
    opacity: 0.2;
  }
`;

export const CloseButton = styled.div`
  position: absolute;
  background-color: red;
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 50%;
  right: 0rem;
  top: 0rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const PriceInput = styled(Input)`
  min-width: 9.5rem;
  width: 9.5rem;
`;

export const ClearMediaText = styled(Text14Regular)`
  cursor: pointer;
  text-decoration-line: underline;
  color: #1672ba;
  user-select: none;
`;

export const FooterContent = styled.div`
  display: flex;
  gap: 1.2rem;
`;

export const SelectedMediaContainer = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 0.2rem;
`;

export const AdditionalOptionsContainer = styled.div``;

export const Row = styled.div`
  display: flex;
  gap: 2rem;
`;

export const NumberInput = styled(NumericInput)`
  width: unset;
  input {
    width: 25rem;
    padding: 1.4rem 1.6rem;
    padding-left: 2rem;
  }
  span {
    top: 3.7rem;
    font-size: 1.5rem;
  }
`;

export const InfiniteScrollMarker = styled.div`
  min-height: 1rem;
`;

export const LoaderMoreContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 5rem;
`;

export const MessageRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ $role }) => ($role === 'USER' ? 'flex-start' : 'flex-end')};
  margin-bottom: 16px;
  position: relative;
`;

export const MessageBubble = styled.div`
  background-color: ${({ $role, $pending }) => ($pending ? '#dddddd' : $role === 'USER' ? '#ffffff' : '#BADAF7')};
  color: #000;
  border-radius: 12px;
  padding: 0.6rem;
  line-height: 1.4;
  position: relative;
  box-shadow: ${({ role }) => (role === 'USER' ? '0 1px 2px rgba(0, 0, 0, 0.08)' : '0 1px 2px rgba(0, 0, 0, 0.12)')};
  font-size: 16px;
  font-weight: 400;
  min-width: ${({ $isAudio }) => ($isAudio ? '11rem' : '6.3rem')};
  max-width: 65%;
  word-wrap: break-word;
`;

export const MessageSpinner = styled.img`
  width: 2.4rem;
  height: 2.4rem;
  position: absolute;
  left: -3rem;
  top: 1.4rem;
`;

export const VoiceResponseText = styled(Text12Light)``;

export const TimeText = styled(Text12Light)`
  font-weight: ${$purchased => !$purchased && '600'};
`;

export const DateDivider = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  margin: 2.4rem 0;

  p {
    opacity: 0.4;
    letter-spacing: -0.42px;
  }
`;

export const DateDividerLine = styled.div`
  flex: 1;
  background: #d2d6db;
  height: 1px;
`;

export const MediaWrapper = styled.div`
  width: 20rem;
  background-color: ${({ $role }) => ($role === 'USER' ? '#ffffff' : '#badaf7')};
  box-shadow: ${({ role }) => (role === 'USER' ? '0 1px 2px rgba(0, 0, 0, 0.08)' : '0 1px 2px rgba(0, 0, 0, 0.12)')};
  padding: 0.4rem;
  border-radius: 1.2rem;
  position: relative;
  cursor: pointer;
`;

export const RepresentativeMedia = styled.div`
  position: relative;
`;

export const FreePreviewWrapper = styled.div`
  border-radius: 4px;
  padding: 2px 6px;
  position: absolute;
  background: rgba(0, 0, 0, 0.56);
  z-index: 10;
  top: 2px;
  left: 2px;
  font-size: 1.1rem;
  font-weight: 500;
  color: #fff;
`;

export const MediaFooter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: 'space-between';
  gap: 0.4rem;
  margin-top: 1rem;
`;

export const FooterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PinWrapper = styled.button`
  background-color: transparent;
  border: none;
`;

export const PlayIconWrapper = styled.div`
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  /* background: rgba(0, 0, 0, 0.56); */
  z-index: 10;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const CancelContainer = styled.div``;

export const CancelButton = styled(Text13Bold)`
  text-decoration-line: underline;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? '0.3' : '1')};
`;
